import React from "react";

const VARIANTS = {
  primary:
    "bg-darkblue text-white hover:opacity-90 border border-transparent",
  secondary:
    "bg-white text-gray-800 border border-gray-200 hover:bg-gray-50",
  danger:
    "bg-red-600 text-white hover:bg-red-700 border border-transparent",
  ghost:
    "bg-transparent text-gray-700 border border-transparent hover:bg-gray-50",
  soft:
    "bg-blue-50/50 text-blue-600 border border-blue-200 hover:bg-blue-50",
};

const SIZES = {
  sm: "h-8 px-3 text-sm rounded-2xl gap-1.5",
  md: "h-9 px-4 text-sm rounded-2xl gap-1.5",
  lg: "h-11 px-5 text-base rounded-2xl gap-2",
  icon: "size-9 rounded-2xl p-0",
};

/**
 * Shared app button — use this instead of one-off Tailwind button classes.
 *
 * @param {"primary"|"secondary"|"danger"|"ghost"|"soft"} variant
 * @param {"sm"|"md"|"lg"|"icon"} size
 */
export default function Button({
  variant = "primary",
  size = "md",
  fullWidth = false,
  className = "",
  type = "button",
  disabled = false,
  children,
  ...props
}) {
  return (
    <button
      type={type}
      disabled={disabled}
      className={[
        "inline-flex items-center justify-center font-semibold transition-all",
        "disabled:cursor-not-allowed disabled:opacity-50",
        VARIANTS[variant] || VARIANTS.primary,
        SIZES[size] || SIZES.md,
        fullWidth ? "w-full" : "",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
      {...props}
    >
      {children}
    </button>
  );
}
